import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js"

// Themes the charts of an embedded report frame (Insights::FrameEmbedsController)
// for a dark surface. Janela themes a pane through its --janela-* custom
// properties, but a chart's axis labels and gridlines are Chart.js defaults it
// does not expose, so they are set here, once, before the panes load their
// charts (they load lazily, after this controller connects). Only the embed page
// carries this controller, so nothing else in the app is affected.
export default class extends Controller {
  static values = { ink: String, grid: String }

  connect() {
    if (this.hasInkValue) Chart.defaults.color = this.inkValue
    if (this.hasGridValue) Chart.defaults.borderColor = this.gridValue
  }
}
